

export default {
    totalRecords: 0
}
